import React from "react"
import { Link } from "@tanstack/react-router"
import { AlertTriangle } from "lucide-react"
import { Button } from "@/components/ui/button"

/**
 * Not found page shown when a user navigates to an unknown route.
 *
 * @returns Centered error state with a quick link back to the home page.
 */
const NotFound: React.FC = () => {
  return (
    <main className="bg-background text-foreground flex min-h-screen items-center justify-center px-6 py-12">
      <div className="bg-card text-card-foreground w-full max-w-xl rounded-2xl p-10 text-center shadow-sm">
        <AlertTriangle className="text-primary mx-auto mb-4 h-12 w-12" aria-hidden="true" />
        <p className="text-muted-foreground text-sm font-medium tracking-wide uppercase">404 error</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">Page not found</h1>
        <p className="text-muted-foreground mt-4 text-base leading-relaxed">
          We couldn&apos;t find the page you&apos;re looking for. It may have been moved, renamed, or never existed.
        </p>
        <div className="mt-8 flex justify-center">
          <Button asChild>
            <Link to="/">Go to home</Link>
          </Button>
        </div>
      </div>
    </main>
  )
}

export default NotFound
